import { render, staticRenderFns } from "./ActiveProposals.vue?vue&type=template&id=1e61a6b7&"
import script from "./ActiveProposals.vue?vue&type=script&lang=js&"
export * from "./ActiveProposals.vue?vue&type=script&lang=js&"
import style0 from "./ActiveProposals.vue?vue&type=style&index=0&id=1e61a6b7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports